// Update cart in header when React cart is updated
// The React does not use the cart fragments used in other templates.
window.addEventListener("DOMContentLoaded", () => {
    if (!window.wp || !window.wp.data || !window.wp.data.select('wc/store/cart')) {
        return;
    }

    const subscribe = wp.data.subscribe;
    let lastCount = null;
    subscribe(function () {
        const itemCount = window.wp.data.select('wc/store/cart').getCartData().itemsCount
        if (itemCount !== lastCount) {
            lastCount = itemCount;
            jQuery('.header__cart-count').text(itemCount);
        }
    });
});